import runtimeEnv from "@mars/heroku-js-runtime-env";
const env = runtimeEnv();

export default async function fetchAuth(prueba, countryCode) {
  // console.log(prueba)
  const originalCodeContry = localStorage.getItem("originalCodeContry");
  const codeCountry = localStorage.getItem("codeCountry");
  const clientId = localStorage.getItem("clientId");

  const urlService = env.REACT_APP_SERVICES_URL + `oauth/token/${codeCountry}`;
  var details = {
    grant_type: "client_credentials",
    client_id: clientId,
    client_secret: env.REACT_APP_SERVICES_CLIENT_SECRET,
  };
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return fetch(urlService, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + env.REACT_APP_ACCESS_TOKEN,
      codecountry: originalCodeContry,
    },
    body: formBody,
  })
    .then((response) => {
      // console.log('response del token', response)
      if (response.ok) {
        return response.text();
      }
      throw new Error("Something went wrong.");
    })
    .then((data) => {
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    })
    .catch((e) => {
      console.log(e);
    });
}
